/* eslint-disable import/no-cycle */
import ApiService from '@/services/api.service';
import { appEndpoint } from '@/shared';
import {
  TooManyAttemptsError, ValidationError, PMSError, HttpError,
} from '@/errors';

/* eslint-disable no-shadow */
const state = {
  translation: null,
  translationKey: null,
  loading: false,
  error: null,
  // translatedPages: null,
  translatedLanguages: null,
  updateError: null,
  language: null,
  translationPending: true,
  translationLanguageiso: null,
  translatingText: false,
  settingPreference: false,
  gettingPreference: false,
};

const getters = {
  getTranslation: (state) => state.translation,
  loaded: (state) => !state.loading && state.translation != null,
  // translatedPages: (state) => state.translatedPages,
  translatedLanguages: (state) => (state.translatedLanguages != null ? state.translatedLanguages : []),
  getLanguages: (state) => (state.language),
  translationLanguageiso: (state) => (state.translationLanguageiso),
};

const mutations = {
  clearErrors(state) {
    state.error = null;
    state.updateError = null;
  },
  getTranslation(state, data) {
    // state.translatedLanguages = data.iso;
    state.translationLanguageiso = data.iso;
    /* TODO temp solution with hardcoded iso, because we don't have translations for all languages */
    state.translatedLanguages = ['en', 'de', 'pt', 'tr', 'ar', 'es', 'fr', 'it', 'nl', 'pl', 'ro', 'ru', 'sl', 'zh', 'da', 'bg'];
    state.translation = data.translations;
  },
  translateLanguage(state, data) {
    state.language = data;
    state.translationPending = false;
  },
  beforeTranslation(state) {
    state.translationPending = true;
  },
  afterTranslation(state) {
    state.translationPending = false;
  },
  beforeTranslatingText(state) {
    state.translatingText = true;
  },
  afterTranslatingText(state) {
    state.translatingText = false;
  },
  beforeSetPreference(state) {
    state.settingPreference = true;
  },
  afterSetPreference(state) {
    state.settingPreference = false;
  },
  beforeGetPreference(state) {
    state.gettingPreference = true;
  },
  afterGetPreference(state) {
    state.gettingPreference = false;
  },
};

function handleApiError(commit, error) {
  const { status, data } = error.response;
  const rlr = error.response.headers['x-ratelimit-reset'] || 0;
  let err = error;
  switch (status) {
    case 400: // BadRequest
      err = new HttpError(status, data.message);
      break;
    case 409: // PMSError
      err = new PMSError(status, data.message);
      break;
    case 422:
      err = new ValidationError(status, data.message, data.errors);
      break;
    case 429:
      return new TooManyAttemptsError(rlr ? data.message : data.errors.email[0], rlr);
    case 500:
      err = new Error(data.message);
      break;
    default:
      break;
  }
  throw err;
}

const actions = {
  async getTranslate({ commit }, payload) {
    if (payload.language) {
      commit('beforeTranslation');
    }
    const data = await ApiService.post(`${appEndpoint}/translations`, payload);
    if (data) {
      commit('translateLanguage', data.data);
      return data.data;
    }
    if (payload.language) {
      commit('afterTranslation');
    }
    return [];
  },
  async translateText({ commit }, payload) {
    commit('beforeTranslatingText');
    try {
      const { data } = await ApiService.post(`${appEndpoint}/api/data/translate-text`, payload);
      return data;
    } catch (error) {
      throw handleApiError(commit, error);
    } finally {
      commit('afterTranslatingText');
    }
  },
  async getPreference({ commit }, payload) {
    commit('beforeGetPreference');
    try {
      const { data } = await ApiService.get(`${appEndpoint}/api/translation-language-preferences/get`, {
        params: payload,
      });
      return data;
    } catch (error) {
      throw handleApiError(commit, error);
    } finally {
      commit('afterGetPreference');
    }
  },
  async setPreference({ commit }, payload) {
    commit('beforeSetPreference');
    try {
      await ApiService.post(`${appEndpoint}/api/translation-language-preferences/set`, payload);
    } catch (error) {
      throw handleApiError(commit, error);
    } finally {
      commit('afterSetPreference');
    }
  },
  async removePreference({ commit }, payload) {
    commit('beforeSetPreference');
    try {
      await ApiService.delete(`${appEndpoint}/api/translation-language-preferences/remove`, {
        params: payload,
      });
    } catch (error) {
      throw handleApiError(commit, error);
    } finally {
      commit('afterSetPreference');
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
